module.exports = __webpack_public_path__ + "static/media/product-ar.be5c7727.gif";